<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 py3 mb2">
      <div class="col-12 px2">
        <div class="clearfix border muted-border p2 py3 shadow" v-if="showMobile">
          <div class="col-12 px2 gibson">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Dit abonnement</p>
            <p class="h5 regular darkblue line-height-golden mb3">
               Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på <a href="tel:+4570228014" class="primarycolor semi-bold">70 22 80 14</a> eller skriv til <a href="mailto:info@haandvaerker.dk" class="primarycolor semi-bold">info@haandvaerker.dk</a>.
            </p>
          </div>
          <div v-if="showMobile" class="col-12 flex flex-column my3">
            <p class="h2 gibson hide semi-bold darkblue line-height-1">
              Total Stats
            </p>
            <div class="clearfix px0 flex flex-column pt1 pb3 white gibson">
              <span v-if="stats.TotalSearch > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-search"></i></span>
                <span>{{stats.TotalSearch}} Søgeresultater</span>
              </span>
              <span v-if="stats.TotalProfileView > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span>{{stats.TotalProfileView}} Profil visninger</span>
              </span>
              <span v-if="stats.TotalContactView > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span>{{stats.TotalContactView}} Kontaktoplysninger vist</span>
              </span>
              <span v-if="stats.TotalRatingInTimePeriod > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <div class="my1 flex justify-center">
                  <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.1" :item-size="24" :spacing="1" :show-rating="false" :rating="3.2" :read-only="true"></image-rating>
                </div>
                <span>{{stats.TotalRatingInTimePeriod}} Nye anbefalinger</span>
              </span>
              <span v-if="stats.TotalAllTimeRating > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <div class="my1 flex justify-center">
                  <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.1" :item-size="24" :spacing="1" :show-rating="false" :rating="stats.TotalAllTimeRating" :read-only="true"></image-rating>
                </div>
                <span>{{stats.TotalAllTimeRating}} Total rating</span>
              </span>
              <span v-if="stats.TotalJobCreated > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-data-line"></i></span>
                <span>{{stats.TotalJobCreated}} Opgaver</span>
              </span>
              <span v-if="stats.TotalHtJob > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-data-line"></i></span>
                <span>{{stats.TotalHtJob}} Opgave(r) fra kunder</span>
              </span>
              <span v-if="stats.TotalProfileSave > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-collection"></i></span>
                <span>{{stats.TotalProfileSave}} Profil gemt</span>
              </span>
              <span v-if="stats.TotalProjectSave > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-collection"></i></span>
                <span>{{stats.TotalProjectSave}} Projekter gemt</span>
              </span>
              <span v-if="stats.TotalProjectClick > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-thumb"></i></span>
                <span>{{stats.TotalProjectClick}} Klik på dine projekter</span>
              </span>
              <span v-if="stats.TotalProjectView > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span>{{stats.TotalProjectView}} Projekt visninger</span>
              </span>
              <span v-if="stats.PhoneView > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span>{{stats.PhoneView}} project clicks</span>
              </span>
              <span v-if="stats.GalleryView > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span>{{stats.GalleryView}} project clicks</span>
              </span>
              <span v-if="stats.CommentView > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span>{{stats.CommentView}} Anbefalinger læst</span>
              </span>
              <span v-if="stats.Shared > 0" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span class="block"><span class="mr1">{{stats.Shared}}</span> Profil-delinger</span>
              </span>
              <span v-if="stats.RatingGradeText != null" class="h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <p class="h6 line-height-4 darkblue gibson">{{stats.RatingGradeText}}</p>
              </span>
            </div>
          </div>
          <div class="col-12">
            <b-alert variant="success" dismissible :show="showDismissibleAlert" @dismissed="showDismissibleAlert=false">
              <h5>Abonnement</h5>
            </b-alert>
          </div>
          <div class="col-12 px2 mb3">
            <button @click="openUrl('downloada.php?id='+salesPerson)"  class="primary-button p2 gibson flex justify-center items-center border-none not-rounded h5 line-height-1 mb2">
              <span>Dit abonnement</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
            <p class="h6 darkblue regular gibson line-height-1 mb2">Download aftale her</p>
          </div>
          <div class="col-12 px2 mb3">
            <button @click="showMeetingDetailsAflysetext()" class="outlined-action-button p2 gibson flex justify-center items-center not-rounded h5 lin-eheight-1 mb2">
              <span>Løsninger</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
            <p class="h6 darkblue regular gibson line-height-1 mb2">Klik her og bliv kontaktet vedr. din løsning</p>
          </div>
          <div class="col-12 px2 mb3" v-if="!opsigedone">
            <button @click="opsig()" class="outlined-delete-button p2 gibson flex justify-center items-center not-rounded h5 line-height-1 mb2" style="border:color:currentColor;">
              <span>Opsig</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
          </div>
          <div class="col-12 px2 mb3" v-if="opsigedone">
            <p class="h6 darkblue regular gibson line-height-1 mb2">Du har allerede opsagt din aftale</p>
          </div>
          <div class="px2" v-if="lytid !== ''">
            <button @click="openUrl('audio.php?id='+lytid)"  class="outlined-disabled-button p2 gibson flex justify-center items-center not-rounded h5 line-height-1 mb2">
              <span>Download lydfilen</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
          </div>
        </div>
        <div class="clearfix p2 py3 ml4" v-if="!showMobile">
          <b-alert v-if="retentionStatus = true" variant="light" :show="dismissCountDown" fade dismissible @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
            <span slot="dismiss" class="px2">
              <i class="darkblue el-icon-close"></i>
            </span>
            <div slot="default">
              <div class="clearfix white-background darkblue">
                <div class="py2">
                  <h4 class="h4 line-height-1 gibson">{{retentionTitle}}</h4>
                  <p>
                    {{retentionMessage}} {{ dismissCountDown }} seconds...
                  </p>
                </div>
              </div>
            </div>
          </b-alert>
          <div class="col-12 px2 gibson">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Dit abonnement</p>
            <p class="h5 regular darkblue line-height-golden mb3">
               Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på <a href="tel:+4570228014" class="primarycolor semi-bold">70 22 80 14</a> eller skriv til <a href="mailto:info@haandvaerker.dk" class="primarycolor semi-bold">info@haandvaerker.dk</a>.
            </p>
          </div>
          <div v-if="!showeMobile" class="col-12 flex flex-column my3">
            <p class="h2 gibson semi-bold darkblue line-height-1">
              Total Stats
            </p>
            <!-- <p class="h6 darkblue light line-height-1">{{moment(stats.ActionDate).format('YYYY-MM-DD')}}</p> -->
            <div class="clearfix px0 flex flex-wrap pt1 pb3 white gibson">
              <span v-if="stats.TotalSearch > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-search"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalSearch}}</span><span>Søgeresultater</span></span>
              </span>
              <span v-if="stats.TotalProfileView > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalProfileView}}</span> Profil visninger</span>
              </span>
              <span v-if="stats.TotalContactView > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalContactView}}</span>contact views</span>
              </span>
              <span v-if="stats.TotalRatingInTimePeriod > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <div class="mt1 flex justify-center">
                  <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.1" :item-size="24" :spacing="1" :show-rating="false" :rating="3.2" :read-only="true"></image-rating>
                </div>
                <span class="block mt2"><span>{{stats.TotalRatingInTimePeriod}}</span> Nye anbefalinger</span>
              </span>
              <span v-if="stats.TotalAllTimeRating > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <div class="mt1 flex justify-center">
                  <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.1" :item-size="24" :spacing="1" :show-rating="false" :rating="stats.TotalAllTimeRating" :read-only="true"></image-rating>
                </div>
                <span class="block mt2"><span class="mr1">{{stats.TotalAllTimeRating}}</span>Total rating</span>
              </span>
              <span v-if="stats.TotalJobCreated > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-data-line"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalJobCreated}}</span>Opgaver</span>
              </span>
              <span v-if="stats.TotalHtJob > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-data-line"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalHtJob}}</span>Opgave(r) fra kunder</span>
              </span>
              <span v-if="stats.TotalProfileSave > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-collection"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalProfileSave}}</span>Profil gemt</span>
              </span>
              <span v-if="stats.TotalProjectSave > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-collection"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalProjectSave}}</span> Projekter gemt</span>
              </span>
              <span v-if="stats.TotalProjectClick > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-thumb"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalProjectClick}}</span> Klik på dine projekter</span>
              </span>
              <span v-if="stats.TotalProjectView > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span class="block"><span class="mr1">{{stats.TotalProjectView}}</span> Projekt visninger</span>
              </span>
              <span v-if="stats.PhoneView > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span class="block"><span class="mr1">{{stats.PhoneView}}</span>project clicks</span>
              </span>
              <span v-if="stats.GalleryView > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span class="block"><span class="mr1">{{stats.GalleryView}}</span>project clicks</span>
              </span>
              <span v-if="stats.CommentView > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span class="block"><span class="mr1">{{stats.CommentView}}</span> Anbefalinger læst</span>
              </span>
              <span v-if="stats.Shared > 0" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <span class="block"><span class="mr1">{{stats.Shared}}</span> Profil-delinger</span>
              </span>
              <span v-if="stats.RatingGradeText != null" class="h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center">
                <span class="h1 green"><i class="el-icon-view"></i></span>
                <p class="h6 line-height-4 darkblue gibson">{{stats.RatingGradeText}}</p>
              </span>
            </div>
          </div>
          <div class="col-6">
            <b-alert variant="success" dismissible :show="showDismissibleAlert" @dismissed="showDismissibleAlert=false">
              <h5>Abonnement</h5>
            </b-alert>
          </div>
          <div class="flex flex-wrap">
            <div class="mr1 px2 mb3">
              <button @click="openUrl('downloada.php?id='+salesPerson)" target="_blank" class="primary-button p2 gibson flex justify-center items-center border-none not-rounded h5 line-height-1 mb2">
                <span>Dit abonnement</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
              <p class="h6 darkblue regular gibson line-height-1 mb2">Download aftale her</p>
            </div>
            <div class="mr1 px2 mb3">
              <button @click="showMeetingDetailsAflysetext()" class="outlined-action-button p2 gibson flex justify-center items-center not-rounded h5 lin-eheight-1 mb2">
                <span>Løsninger</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
              <p class="h6 darkblue regular gibson line-height-1 mb2">Klik her og bliv kontaktet vedr. din løsning</p>
            </div>
            <div class="mr1 px2 mb3" v-if="!opsigedone">
              <button @click="opsig()" class="outlined-delete-button p2 gibson flex justify-center items-center not-rounded h5 line-height-1 mb2" style="border:color:currentColor;">
                <span>Opsig</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <div class="mr1 px2 mb3" v-if="opsigedone">
              <p class="h6 darkblue regular gibson line-height-1 mb2">Du har allerede opsagt din aftale</p>
            </div>
            <div class="mr1 px2" v-if="lytid !== ''">
              <button @click="openUrl('audio.php?id='+lytid)" target="_blank" class="outlined-disabled-button p2 gibson flex justify-center items-center not-rounded h5 line-height-1 mb2">
                <span>Download lydfilen</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py3"></div>
    <div v-if="showMobile">
      <el-dialog v-if=" retentionStatus = true" width="80%" :show-close="false" :visible.sync="retentionModal">
        <div class="clearfix">
          <p class="h4 darkblue gibson" slot="title">{{retentionTitle}}</p>
          <p class="h6 darkblue gibson line-height-4">{{retentionMessage}}</p>
          <div class="py2"></div>
          <button class="muted-button mx-auto flex justify-center items-center p2 gibson h5 line-height-1 regular" @click="retentionModal = false">
            <span>Luk</span>
          </button>
        </div>
      </el-dialog>
    </div>
    <div v-if="!showMobile">
      <el-dialog v-if="retentionStatus = true " width="50%" :show-close="false" :visible.sync="retentionModal">
        <div class="clearfix">
          <p class="h4 darkblue gibson" slot="title">{{retentionTitle}}</p>
          <p class="h6 darkblue gibson line-height-4">{{retentionMessage}}</p>
          <div class="py2"></div>
          <button class="muted-button mx-auto flex justify-center items-center p2 gibson h5 line-height-1 regular" @click="retentionModal = false">
            <span>Luk</span>
          </button>
        </div>
      </el-dialog>
    </div>
    <b-modal id="modalPrevent" hide-footer v-model="modalShowMail" title="Løsninger" ref="modal" class="p-2 pb-4">
      <div class="line-height-golden text-dark open-sans h6 py-lg-2 py-md-2 py-sm-4">Klik her og bliv kontaktet vedr. din løsning</div>
      <b-form @submit.stop.prevent="handleSubmitMail">
        <b-form-row>
          <b-col class="py-2 py-lg-2 py-md-2 py-sm-2">
            <b-form-textarea v-model="textReason" :rows="6" :max-rows="9" class="bg-light border-0"></b-form-textarea>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="py-lg-2 py-md-2 py-sm-2">
            <b-button class="mt-3 mt-lg-3 mt-md-3 mt-sm-3 rounded float-right" variant="info" type="submit" :disabled="isLoadingMail" size="lg">Send</b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import axios from 'axios'
import moment from 'moment'
import {ImageRating} from 'vue-rate-it'
export default {
  name: 'kreditkort',
  components: {
    Simplert,
    ImageRating
  },
  data () {
    return {
      haaId: '',
      retentionStatus: '',
      retentionTitle: '',
      retentionMessage: '',
      dismissSecs: 10,
      dismissCountDown: 0,
      selected: '',
      salesPerson: '',
      modalShowMail: false,
      isLoadingMail: false,
      textReason: '',
      startend: '',
      lytid: '',
      finishend: '',
      message: '',
      haaCredit: false,
      opsige: false,
      opsigeother: false,
      opsigetext: '',
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      showRetentionPopup: false,
      retentionModal: false,
      stats: [{
        TotalSearch: '',
        TotalProfileView: '',
        TotalContactView: '',
        TotalRatingInTimePeriod: '',
        TotalAllTimeRating: '',
        TotalJobCreated: '',
        TotalHtJob: '',
        TotalProfileSave: '',
        TotalProjectSave: '',
        TotalProjectClick: '',
        TotalProjectView: '',
        TotalPhoneView: '',
        TotalGalleryView: '',
        TotalCommentView: '',
        Shared: ''
      }]
    }
  },
  methods: {
    showRetentionModal () {
      this.retentionModal = true
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    cancelLeadIntegrationTrial () {
      this.haaId = localStorage.getItem('haaid')
      var data = {
        partnerId: this.haaId
      }
      this.$http.POST('https://bitrixapi.haandvaerker.dk/v1/bitrix/cancelLeadIntegrationTrial', {data}, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
            }
          },
          response => {
            console.log('error in loading all udbud')
          }
        )
    },
    openUrl (url) {
      var win = window.open(url, '_blank')
      win.focus()
    },
    opsig () {
      if (this.opsige || this.opsigeother) {
        let confirmFn = function () {
          this.$router.push('/expire-subscription-form')
        }
        let obj = {
          title: 'Vi er kede af at sige farvel...',
          message: '<h5>Og vi håber naturligvis at se dig igen! For at kunne forbedre vores service, vil du blive stillet nogle spørgsmål, inden din opsigelse er gennemført.</h5>',
          type: 'error',
          customCloseBtnText: 'Fortryd',
          customCloseBtnClass: 'btn btn-outline-info',
          customConfirmBtnText: 'Opsig abonnement',
          customConfirmBtnClass: 'btn btn-outline-danger',
          useConfirmBtn: true,
          onConfirm: confirmFn
        }
        this.$refs.simplert.openSimplert(obj)
      } else {
        let obj = {
          title: 'Opsig!',
          message: '<h5>' + this.opsigetext + '</h5>',
          type: 'warning',
          customCloseBtnText: 'Luk'
        }
        this.$refs.simplert.openSimplert(obj)
        this.salesPerson = localStorage.getItem('id_token_portal')
        var data = {operation: 'aftaleexit_partner_profile', salesPerson: this.salesPerson, holiday: 1, array: 'no'}
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              this.cancelLeadIntegrationTrial()
              if (res.login === false) {
                this.$router.push('/login')
              }
            },
            response => {
              alert('error')
            }
          )
      }
    },
    showMeetingDetailsAflysetext () {
      this.modalShowMail = true
    },
    handleSubmitMail () {
      this.isLoadingMail = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'aftalemail_partner_profile', salesPerson: this.salesPerson, textReason: this.textReason}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowMail = false
              let obj = {
                title: 'Vi kontakter dig snarest muligt!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.isLoadingMail = false
              this.textReason = ''
            } else {
              alert(res.message)
              this.isLoadingMail = false
            }
          },
          response => {
            alert('error')
          }
        )
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true
    }
    if (localStorage.getItem('imentor') === '0') {
      this.showimentor = false
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    var data = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no'}
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          if (res.login === false) {
            this.$router.push('/login')
          }
          this.opsige = res.opsige
          this.opsigeother = res.opsigeother
          this.opsigetext = res.opsigetext
          if (res.startend !== '') {
            this.message = 'Dit abonnement er desværre i binding, du kan opsige dit abonnement i denne periode: Fra d. ' + res.startend + ' til ' + res.finishend
          } else {
            this.message = 'Dit abonnement er desværre i binding, du kan opsige dit abonnement'
          }
          this.opsigedone = res.opsigedone
          this.lytid = res.lytid
        },
        response => {
          alert('error')
        }
      )
  },
  mounted () {
    try {
      axios
        .get('https://newcrm.kundematch.dk/bitrix/components/hvdk/webapi/bitrix.php?operation=getRetentionPopup')
        .then((res) => {
          if (res.data.success === true) {
            var results = res.data.data[0]
            this.retentionTitle = results.NAME
            this.retentionMessage = results.PROPERTY_POPUP_TEXT_VALUE.TEXT
            console.log(res.data.data[0].NAME)
            // this.showAlert()
          }
        })
        .catch(function () {
          console.log('Error')
        })
      var retId = localStorage.getItem('haaid')
      // console.log(retId)
      var date = new Date()
      // console.log(date.setDate(date.getDate() + 1))
      var newEndDate = moment(date.setDate(date.getDate() + 1)).format('YYYY-MM-DD')
      // console.log(newEndDate)
      // moment(email.createtime).format('lll')
      axios
        .get('http://webapi.haandvaerker.dk/v1/activity/GetSupplierLogByData2?supplierid=' + retId + '&startdate=2010-01-01&enddate=' + newEndDate)
        .then((res) => {
          // var stats = res.data
          this.stats = res.data
          // console.log(this.stats)
          // console.log(res)
          /* this.retentionTitle = res.data */
          /* this.showAlert() */
        })
        .catch(function () {
          console.log('Error')
        })
    } catch (e) {
    }
    this.retentionModal = false
  },
  watch: {
    haaid (newHaaid) {
      localStorage.haaid = newHaaid
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// ExpireSubscription.vue?d4cc1a6e